let bsParams = {
  publishName: "", // 出版单位名称
  publishAddr: "", // 出版单位地址
  publishPostalcode: "", // 出版单位邮政编码
  publishLinkman: "", // 出版单位联系人
  publishTel: "", // 出版单位联系电话

  hostName: "", // 主办单位
  chargeName: "", // 主管单位

  workers: "", // 职工总数
  businessWorkers: "", // 连续型电子出版物业务人员数
  otherWorkers: "", // 其中取得中级以上资格证书人员数
  unitType: "", // 法人身份
  evolution: "", // 演变情况
  remark: "", // 备注

  id: "", // id
  publishMaterialId: "", // 当前年度，出版单位填写资料表，资料表Id

  publishId: "", // 出版单位ID
  hostId: "", // 主办单位ID
  chargeId: "", // 主管单位ID
};

let zipCode = (rule, val, callback) => {
  // 邮编验证
  var pattern = /(^[0-9]{6})$/;
  if (val == "") {
    callback(new Error("请输入单位邮编"));
  } else if (!pattern.test(val)) {
    callback(new Error("邮编格式错误！"));
  } else {
    callback();
  }
};

let mobelPhone = (rule, val, callback) => {
  // 手机验证
  var pattern = /^1[0-9]{10}$/;
  if (val == "") {
    callback(new Error("请输入手机号"));
  } else if (!pattern.test(val)) {
    callback(new Error("手机号格式错误！"));
  } else {
    callback();
  }
};

let paramsRule = {
  publication: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ],
  publishName: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ], // 出版单位名称
  publishAddr: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ], // 出版单位地址
  publishPostalcode: [{ validator: zipCode, trigger: "blur" }], // 出版单位邮政编码
  publishLinkman: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ], // 出版单位联系人
  publishTel: [{ validator: mobelPhone, trigger: "blur" }], // 出版单位联系电话

  hostName: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ], // 主办单位
  chargeName: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ], // 主管单位

  workers: [{ required: true, message: "不能为空！", trigger: "change" }], // 职工总数
  businessWorkers: [{ required: true, message: "不能为空！", trigger: "change" }], // 连续型电子出版物业务人员数
  otherWorkers: [{ required: true, message: "不能为空！", trigger: "change" }], // 其中取得中级以上资格证书人员数
  unitType: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ], // 法人身份
  evolution: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ], // 演变情况

  firstTotalSales: [{ required: true, message: "不能为空！", trigger: "change" }], // 2023年出版单位年销售收入（万元）
  secondTotalSales: [{ required: true, message: "不能为空！", trigger: "change" }], // 2024年出版单位年销售收入（万元）
  firstTotalProfit: [{ required: true, message: "不能为空！", trigger: "change" }], // 2023出版单位年度利润（税后）总额（万元）
  secondTotalProfit: [{ required: true, message: "不能为空！", trigger: "change" }], // 2024出版单位年度利润（税后）总额（万元）

  remark: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ], // 备注
};

export { bsParams, paramsRule };



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsSEt2.js